import React, { useState } from 'react'
import styled from 'styled-components'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'

const seen = key => {
  try { return window.localStorage.getItem(key) === '1' } catch { return false }
}
const markSeen = key => {
  try { window.localStorage.setItem(key, '1') } catch { /* private mode */ }
}

const OnceCallout = ({ storageKey, icon, tone = 'info', title, children, actions }) => {
  const [open, setOpen] = useState(() => !seen(storageKey))
  if (!open) return null

  const dismiss = () => { markSeen(storageKey); setOpen(false) }

  return (
    <Wrap $tone={tone} role='note'>
      {icon && <IconTile $tone={tone}>{icon}</IconTile>}
      <Body>
        {title && <Title>{title}</Title>}
        <Text>{children}</Text>
        {actions && <ActionRow>{actions}</ActionRow>}
      </Body>
      <Close type='button' aria-label='Dismiss' onClick={dismiss}>
        <CloseRoundedIcon style={{ fontSize: 16 }} />
      </Close>
    </Wrap>
  )
}

export default OnceCallout

const TONES = {
  info:   { fg: '#1f8c97', bg: '#f0fbfc', border: 'rgba(51,190,204,0.30)', tile: 'rgba(51,190,204,0.12)' },
  review: { fg: '#d97706', bg: '#fffbeb', border: '#fcd34d', tile: '#fef3c7' },
}

const Wrap = styled.div`
  display: flex; align-items: flex-start; gap: 12px;
  padding: 14px 16px;
  margin-bottom: 16px;
  border-radius: 12px;
  background: ${({ $tone }) => TONES[$tone].bg};
  border: 1px solid ${({ $tone }) => TONES[$tone].border};
`

const IconTile = styled.span`
  display: inline-flex; align-items: center; justify-content: center;
  width: 34px; height: 34px; flex-shrink: 0;
  border-radius: 9px;
  color: ${({ $tone }) => TONES[$tone].fg};
  background: ${({ $tone }) => TONES[$tone].tile};
`

const Body = styled.div` flex: 1; min-width: 0; `

const Title = styled.div`
  font-size: 14px; font-weight: 800;
  letter-spacing: -0.1px;
  color: ${({ theme }) => theme.colors.haiti};
  margin-bottom: 2px;
`

const Text = styled.div`
  font-size: 12.5px; line-height: 1.5;
  color: ${({ theme }) => theme.colors.grey[800]};
  strong { color: ${({ theme }) => theme.colors.haiti}; }
`

const ActionRow = styled.div`
  display: flex; gap: 8px; flex-wrap: wrap; margin-top: 10px;
`

const Close = styled.button`
  font: inherit; cursor: pointer;
  flex-shrink: 0;
  display: inline-flex; align-items: center; justify-content: center;
  width: 26px; height: 26px;
  border: none; background: transparent;
  color: ${({ theme }) => theme.colors.grey[800]};
  border-radius: 7px;
  opacity: 0.6;
  &:hover { opacity: 1; background: rgba(12,18,41,0.05); }
`
